/** @jsx jsx */
import styled from '@emotion/styled';
import { MDXProvider } from '@mdx-js/react';
import { ThemeProvider as EmotionThemeProvider, jsx } from '@emotion/react';
import { Fragment, createRef } from 'react';
import { onXlg, onMd, onSm, onLg, onXxlg } from '../../styles/responsive';
import MdxComponents from '../MdxComponents';
import TableOfContents from '../TableOfContents/TableOfContents';
import { Header } from '../Header/Header';
import { headerHeight, pageLayout, theme } from '../../theme';
import { SidebarNavigation } from '../Sidebar/Sidebar';
import '../../styles/main.css';
import '../../styles/fonts.css';
import CookieConsentBanner from '../CookieConsentBanner/CookieConsentBanner';

const Wrapper = styled.div`
  display: flex;
  overflow-wrap: anywhere;
  justify-content: space-between;
  position: relative;
  ${onXlg} {
    padding-left: 130px;
  }
  ${onMd} {
    top: ${headerHeight};
  }
  ${onSm} {
    min-height: 95vh;
  }
`;

const Content = styled('main')`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  padding: 35px 35px;
  ${onMd} {
    margin-left: ${pageLayout.sidebarWidth};
    padding: 40px 45px;
  }
  ${onLg} {
    margin-right: ${pageLayout.tocWidth};
    padding: 30px 53px 22px 47px;
  }
  ${onXlg} {
    margin-right: ${pageLayout.tocWidthXlg};
    padding: 40px 90px 30px 60px;
  }
  ${onXxlg} {
    margin-left: ${pageLayout.sidebarWidthXxlg};
    margin-right: ${pageLayout.tocWidthXxlg};
  }
  ${onSm} {
    padding: 15px;
  }
`;

const Layout = ({ children, location }) => {
  const themeProviderRef = createRef();

  return (
    <EmotionThemeProvider theme={theme}>
      <CookieConsentBanner />
      <Fragment>
        <Header location={location} themeProvider={themeProviderRef} />
      </Fragment>
      <MDXProvider components={MdxComponents}>
        <Wrapper>
          <SidebarNavigation showOnSm={false} location={location} />
          <Content>{children}</Content>
          <TableOfContents location={location} />
        </Wrapper>
      </MDXProvider>
    </EmotionThemeProvider>
  );
};

export default Layout;
